import 'swiper/dist/css/swiper.css'
import 'viewerjs/dist/viewer.css'
import '@vant/touch-emulator'

import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

import Vue from 'vue'
import { Toast, Uploader, Dialog, Form } from 'vant'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Swiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
import vClickOutside from 'v-click-outside'
import App from './App.vue'
import store from './store'
import VideoPlayer from './components/TheVideoPlayer'
import AudioPlayer from './components/TheAudioPlayer'
import eventBus from './event_bus'
import Directive from './directives'

Vue.config.productionTip = false

// 下拉联级组件
import { Treeselect } from '@riophae/vue-treeselect'
Vue.component('treeselect', Treeselect)
// tag问题分类
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import tag from '@/utils/tag'
Vue.prototype.$tag = tag

Toast.allowMultiple()
Toast.setDefaultOptions({
    getContainer: '.app'
})
Vue.use(Toast)
Vue.use(Uploader)
Vue.use(Form)
Vue.use(Swiper)
Vue.use(Dialog)
Vue.use(VueClipboard)
Vue.use(vClickOutside)
Vue.use(Directive)
Vue.use(ElementUI)

Vue.prototype.$eventBus = eventBus
Vue.prototype.$videoPlayer = VideoPlayer
Vue.prototype.$audioPlayer = AudioPlayer

new Vue({
    store,
    render: h => h(App)
}).$mount('#app')


